import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";
import {
  useAddSalarySalaryAttachment,
  useDeleteSalarySalaryAttachment,
  useGetSalarySalaryAttachments,
} from "src/api/salary/salaries";
import { notificationsState } from "src/store/notifications";
import { APIErrorResponse } from "src/types/generic";
import AttachmentsDialog from "src/shared/components/attachments-dialog";

const SalaryAttachmentsModal = ({
  open,
  onClose,
  salaryId,
  salaryReference,
}: {
  open: boolean;
  onClose: () => void;
  salaryId: number | null;
  salaryReference?: string;
}) => {
  const { t: generalT } = useTranslation("general");
  const [notifications, setNotifications] = useRecoilState(notificationsState);

  const {
    data: attachmentsRes,
    isLoading,
    refetch,
  } = useGetSalarySalaryAttachments(salaryId, open && !!salaryId);
  const data = attachmentsRes?.data ?? [];

  const { mutate: upload, isPending: uploading } =
    useAddSalarySalaryAttachment();
  const { mutate: remove, isPending: removing } =
    useDeleteSalarySalaryAttachment();

  return (
    <AttachmentsDialog
      open={open}
      onClose={onClose}
      entityId={salaryId}
      entityLabel={salaryReference}
      attachments={data}
      isLoading={isLoading}
      refetch={refetch}
      uploading={uploading}
      removing={removing}
      onUpload={(file) => {
        if (!salaryId) return;
        upload(
          { salaryId, file },
          {
            onSuccess: () => {
              refetch();
              setNotifications([
                ...notifications,
                { type: "success", message: generalT("addedSuccessfully") },
              ]);
            },
            onError: (err: APIErrorResponse) => {
              setNotifications([
                ...notifications,
                {
                  type: "error",
                  message:
                    err?.data?.errors?.[0]?.value ?? generalT("somethingWrong"),
                },
              ]);
            },
          },
        );
      }}
      onRemove={(attachmentId, callbacks) => {
        if (!salaryId) return;
        remove(
          { salaryId, salaryFileId: attachmentId },
          callbacks,
        );
      }}
    />
  );
};

export default SalaryAttachmentsModal;
